import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  coursesLanguageFilterMenuAllLanguages: {
    id: 'course-authoring.studio-home.courses.tab.language-filter-menu.all-languages',
    defaultMessage: 'All Languages',
  },
});

export default messages;
